// extracted by mini-css-extract-plugin
export default {"outer":"TopologiesTable_outer__J2D5S","root":"TopologiesTable_root__5TNNQ","name":"TopologiesTable_name__jONe3"};